module.exports = __webpack_public_path__ + "static/media/_MG_3413.c4956e3f.jpg";